<template>
  <form
    @submit.prevent="onSubmit"
    :class="classes"
  >
    <slot />
  </form>
</template>

<script>
export default {
  name: 'Form',
  props: {
    onSubmit: {
      type: Function,
    },
    marginSoft: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  computed: {
    classes() {
      return {
        'form-margin-15': true,
      };
    },
  },
};
</script>
